import styles from './SpyLaunchSettingsPanel.module.css'
import { Calendar2Icon } from 'shared/icons/Calendar2Icon'
import classNames from 'classnames'
import { CustomParams, SlidingParams, SpyLaunchSettings } from 'shared/types/SpyLaunchSettings'
import { DateTime } from 'luxon'
import { spyLaunchSettingsToString } from 'shared/lib/spyLaunchSettingsToString'
import { useMemo } from 'react'
import { SpyLaunchSettingsForm } from '../SpyLaunchSettingsForm'

interface SpyLaunchSettingsPanelProps {
    expanded: boolean
    className?: string
    spyLaunchSettings?: SpyLaunchSettings
    onSummaryClick?: (event: any) => void
    onSpyLaunchSettingsChange?: (event: any) => void
}

export const SpyLaunchSettingsPanel = (props: SpyLaunchSettingsPanelProps): JSX.Element => {
    const {
        expanded = false,
        className,
        spyLaunchSettings,
        onSummaryClick,
        onSpyLaunchSettingsChange
    } = props

    const handleButtonClick = (event: any) => {
        onSummaryClick?.(event)
    }

    const spyLaunchSettingsPanelClasses= classNames(styles.SpyLaunchSettingsPanel, className, {
        [styles[`SpyLaunchSettingsPanel--Expanded`]]: expanded,
    })

    const spyLaunchSettingsButtonClasses = classNames(styles.SpyLaunchSettingsButton, className, {
        [styles[`SpyLaunchSettingsButton--Active`]]: expanded,
        [styles[`SpyLaunchSettingsButton--HasValue`]]: spyLaunchSettings !== undefined
    })

    const SpyLaunchSettingsPanelDetailsClasses = classNames(styles.SpyLaunchSettingsPanel__Details, {
        [styles[`SpyLaunchSettingsPanel__Details--Expanded`]]: expanded,
    })

    const renderValue = (): JSX.Element => {
        if (spyLaunchSettings === undefined){
            return (
                <></>
            )
        }

        const valueString = spyLaunchSettingsToString(spyLaunchSettings)

        return (
            <span className={styles.SpyLaunchSettingsButton__ValueContainer}>
                <span className={styles.SpyLaunchSettingsButton__ValueCaption}>
                    {valueString}
                </span>
            </span>
        )
    }

    const handleSpyLaunchSettingsFormSubmit = (event: any) => {
        onSpyLaunchSettingsChange?.(event)
        console.log(`handleSpyLaunchSettingsFormSubmit`)
    } 

    const hasValue = spyLaunchSettings!== undefined
    const heading = useMemo(() => {
            if (hasValue){
                return `Date`
            }
    
            return 'Select Date'
        }, [
            spyLaunchSettings
    ])
  
    return (
        <div className={spyLaunchSettingsPanelClasses}>
            <div 
                className={styles.SpyLaunchSettingsPanel__Summary}             
            >
                <button
                    className={spyLaunchSettingsButtonClasses}  
                    onClick={handleButtonClick}           
                >
                    <span className={styles.SpyLaunchSettingsButton__HelperContainer}>
                        <span className={styles.SpyLaunchSettingsButton__IconContainer}>
                            <Calendar2Icon className={styles.SpyLaunchSettingsButton__Icon} />
                        </span>
                        <span className={styles.SpyLaunchSettingsButton__Caption}>
                            {heading}
                        </span>               
                    </span>
                    {
                        renderValue()
                    }
                </button>
            </div>
            <div className={SpyLaunchSettingsPanelDetailsClasses}>
                <SpyLaunchSettingsForm 
                    value={spyLaunchSettings}
                    onSubmit={handleSpyLaunchSettingsFormSubmit}
                />
            </div>
        </div>
    )
}